var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 23,
    viewBox: "0 0 18 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 9.58203C17.25 16.2904 8.625 22.0404 8.625 22.0404C8.625 22.0404 0 16.2904 0 9.58203C3.40863e-08 7.29454 0.908703 5.10074 2.5262 3.48323C4.1437 1.86573 6.33751 0.957031 8.625 0.957031C10.9125 0.957031 13.1063 1.86573 14.7238 3.48323C16.3413 5.10074 17.25 7.29454 17.25 9.58203Z",
    fill: "var(--path-color)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.625 12.457C10.2128 12.457 11.5 11.1698 11.5 9.58203C11.5 7.99421 10.2128 6.70703 8.625 6.70703C7.03718 6.70703 5.75 7.99421 5.75 9.58203C5.75 11.1698 7.03718 12.457 8.625 12.457Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPin);
export default __webpack_public_path__ + "static/media/mapPin.9d16f7d566198f02f319f48829afa259.svg";
export { ForwardRef as ReactComponent };